var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "grid-x grid-margin-x grid-padding-y grid-padding-x margin-top-2 margin-bottom-1  align-center",
    },
    [
      _c("div", { staticClass: "cell medium-7 check-item-flame" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x margin-top-1 margin-left-3" }, [
          _c("input", {
            staticClass: "notice-check-item",
            attrs: {
              id: "item-check",
              type: "checkbox",
              "data-test": "notice-item-checkbox",
            },
            domProps: { checked: _vm.accepted },
            on: {
              change: function ($event) {
                return _vm.$emit("update:accepted", $event.target.checked)
              },
            },
          }),
          _vm._v(" "),
          _c("label", {
            staticClass: "notice-check-style",
            attrs: { for: "item-check" },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "boss-color-red notice-check-label",
              attrs: { for: "item-check", "data-test": "notice-label" },
            },
            [_vm._v("\n        " + _vm._s(_vm.noticeLabel) + "\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grid-x grid-margin-x align-center margin-top-1" },
          [_c("div", { staticClass: "cell medium-8" }, [_vm._t("body")], 2)]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information" }, [_c("div", [_vm._v("i")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }